import { useContext } from "react";
import { EBSSSContext } from ".";
import { IEBSSSContext } from "./types";

export const useEBSSS = () => useContext<IEBSSSContext>(EBSSSContext);
